import AvailabilityMapSection, { TITLE_TYPES } from '@root/joinroot.com/src/components/sections/availability-map/availability-map-section';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import get from '@root/vendor/lodash/get';
import renderRichText from '@root/joinroot.com/src/utils/render-rich-text';
import { AUTO_ZIP_CODE_FORM } from '@root/joinroot.com/src/constants';

export default function AvailabilityMapBlock({ content }) {
  const hasAutoZipForm = get(content, 'form.sys.contentType.sys.id') === AUTO_ZIP_CODE_FORM;

  return (
    <div data-testid={'availabilityMapBlock'}>
      <AvailabilityMapSection
        anchor={content.anchor?.anchorSlug}
        body={renderRichText(content.body)}
        eyebrow={content.eyebrow}
        form={hasAutoZipForm}
        titleType={buildTitleType(content.titleType)}
      />
    </div>
  );
}

function buildTitleType(titleType) {
  return titleType.toLowerCase() === 'h1' ? TITLE_TYPES.H1 : TITLE_TYPES.H2;
}

AvailabilityMapBlock.propTypes = {
  content: PropTypes.shape({
    anchor: PropTypes.string,
    body: PropTypes.string,
    eyebrow: PropTypes.string,
    form: PropTypes.shape({
      sys: PropTypes.shape({
        contentType: PropTypes.shape({
          sys: PropTypes.shape({
            id: PropTypes.string.isRequired,
          }).isRequired,
        }).isRequired,
      }).isRequired,
      id: PropTypes.string.isRequired,
    }),
    titleType: PropTypes.string,
  }),
};
